import { IDeliverySpec } from '@/shared/model/delivery-spec.model';
import { IMarketer } from '@/shared/model/marketer.model';
import { IRestaurantWorkingTimes } from '@/shared/model/restaurant-working-times.model';
import { IRestaurant } from '@/shared/model/restaurant.model';
import { IUser } from '@/shared/model/user.model';
import { GetterTree } from 'vuex';
import { RootState } from '../types';
import { ISupportStore } from './types';

export const getters: GetterTree<ISupportStore, RootState> = {
  getTab(state): string {
    return state.tab;
  },
  getDrawer(state): boolean {
    return state.drawer;
  },
  getMarketer(state): IMarketer {
    return state.marketer;
  },
  getMarketerDialog(state): boolean {
    return state.marketerDialog;
  },
  getNewMarketer(state): IMarketer {
    return state.newMarketer;
  },
  getNewMarketerDialog(state): boolean {
    return state.newMarketerDialog;
  },
  getRestaurant(state): IRestaurant {
    return state.restaurant;
  },
  getDeliverySpecs(state): IDeliverySpec[] {
    return state.restaurant.deliverySpecs;
  },
  getRestaurantDialog(state): boolean {
    return state.restaurantDialog;
  },
  getRestaurantWorkingTimes(state): IRestaurantWorkingTimes[] {
    return state.restaurant.restaurantWorkingTimes;
  },
  getNewRestaurant(state): IRestaurant {
    return state.newRestaurant;
  },
  getNewRestaurantDialog(state): boolean {
    return state.newRestaurantDialog;
  },
  getSupport(state): IUser {
    return state.support;
  },
  getSupportDialog(state): boolean {
    return state.supportDialog;
  },
  getUnregisteredRestaurant(state): IUser {
    return state.unregisteredRestaurant;
  },
  getUnregisteredRestaurantDialog(state): boolean {
    return state.unregisteredRestaurantDialog;
  },
  getUpdatedRestaurant(state): IUser {
    return state.updatedRestaurant;
  },
  getUpdatedRestaurantDialog(state): boolean {
    return state.updatedRestaurantDialog;
  },
  getUnregisteredMarketer(state): IUser {
    return state.unregisteredMarketer;
  },
  getUnregisteredMarketerDialog(state): boolean {
    return state.unregisteredMarketerDialog;
  },
};
